import { style } from "typestyle";

export const component = style({
  textDecoration: "none",
  cursor: "pointer !important",
});
